export default __webpack_public_path__ + "static/media/home_you_might_like.1d7e8d33.mp3";